import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const PaymentOption = styled.div`
  cursor: pointer;

  label {
    cursor: pointer;
    display: block;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 15px;
    border: 1px solid ${props => props.theme.form.passiveColor};
    font: ${font('default', 'medium', '15px/1.6')};
    color: ${props => props.theme.palette.general.greyDark};
    border-radius: ${props => props.theme.form.borderRadius};
  }

  svg {
    display: block;
    width: auto;
    height: 20px;
  }

  span {
    display: flex;
    align-items: center;
    padding: 0 0 0 10px;
  }
`
